import type { ReactNode } from 'react';

export function SectionLabel({ children }: { children: string }) {
  return (
    <p className="mb-2.5 text-[10px] font-bold uppercase tracking-[0.18em] text-[var(--text-muted)]">{children}</p>
  );
}

export function ChipGrid({ children }: { children: ReactNode }) {
  return <div className="flex flex-wrap gap-2">{children}</div>;
}

type ChipVariant = 'recent' | 'neutral' | 'outline' | 'create' | 'auto';

export function PickerChip({
  name,
  variant = 'neutral',
  selected = false,
  onClick,
}: {
  name: string;
  variant?: ChipVariant;
  selected?: boolean;
  onClick: () => void;
}) {
  if (selected) {
    return (
      <button
        type="button"
        onClick={onClick}
        className="inline-flex max-w-full items-center gap-1.5 rounded-2xl border border-[#4F8CFF]/55 bg-[#4F8CFF] px-3.5 py-2 text-left text-xs font-semibold text-white shadow-[0_0_20px_rgba(79,140,255,0.28)] transition-all duration-150 active:scale-[0.97]"
      >
        <svg className="h-3.5 w-3.5 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden>
          <path d="M5 12l5 5L20 7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span className="line-clamp-2">{name}</span>
      </button>
    );
  }

  const styles: Record<ChipVariant, string> = {
    recent:
      'border-sky-400/35 bg-sky-500/15 text-sky-100 shadow-[0_0_18px_rgba(79,140,255,0.12)] hover:border-sky-400/50 hover:bg-sky-500/22',
    neutral:
      'border-white/10 bg-white/[0.06] text-[var(--text-secondary)] hover:border-white/16 hover:bg-white/[0.09]',
    outline:
      'border-dashed border-sky-500/35 bg-sky-500/[0.06] text-sky-200 hover:border-sky-400/45 hover:bg-sky-500/10',
    create:
      'border-sky-400/40 bg-gradient-to-br from-sky-500/20 to-blue-600/10 text-sky-100',
    auto:
      'border-violet-400/30 bg-violet-500/10 text-violet-100 hover:border-violet-400/45 hover:bg-violet-500/15',
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex max-w-full items-center rounded-2xl border px-3.5 py-2 text-left text-xs font-semibold leading-snug transition-all duration-150 active:scale-[0.97] ${styles[variant]}`}
    >
      <span className="line-clamp-2">{name}</span>
    </button>
  );
}
